import React from 'react';
import { Routes, Route } from 'react-router-dom';
import FlashScreen from './components/FlashScreen';
import Dashboard from './pages/Dashboard';
import Transactions from './pages/Transactions';
import Users from './pages/Users';
import Operators from './pages/Operators';
import Packages from './pages/Packages';
import GlobalExchange from './pages/GlobalExchange';
import Countries from './pages/Countries';
import Currencies from './pages/Currencies';
import PriceConfig from './pages/PriceConfig';
import Settings from './pages/Settings';
import Sliders from './pages/Sliders';
import Signin from './pages/Signin';
import Signup from './pages/Signup';
import PrivateRoute from './components/PrivateRoute'; // 👈 Add this
import FraudDashboard from './pages/FraudDashboard';   // 🛡️ Fraud Management
import FraudLogs from './pages/FraudLogs';              // 📋 Fraud Logs
import Blacklist from './pages/Blacklist';               // 🚧 Blacklist
import FraudRules from './pages/FraudRules';            // ⚙️ Fraud Rules
import SuspendedUsers from './pages/SuspendedUsers';    // 🔒 Suspended Users
import './assets/css/common.css';
import './assets/css/custom.css';
import ForgetPassword from './components/ForgetPassword';

function App() {
  return (
    <div>
      <Routes>
        <Route path="/" element={<FlashScreen />} />
        <Route path="/signin" element={<Signin />} />
        {/* <Route path="/signup" element={<Signup />} /> */}
        <Route path="/forget-password" element={<ForgetPassword />} />

        {/* 👇 Protected Routes */}
        <Route
          path="/dashboard"
          element={
            <PrivateRoute>
              <Dashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/transactions"
          element={
            <PrivateRoute>
              <Transactions />
            </PrivateRoute>
          }
        />
        <Route
          path="/users"
          element={
            <PrivateRoute>
              <Users />
            </PrivateRoute>
          }
        />
        <Route
          path="/operators"
          element={
            <PrivateRoute>
              <Operators />
            </PrivateRoute>
          }
        />
        <Route
          path="/packages"
          element={
            <PrivateRoute>
              <Packages />
            </PrivateRoute>
          }
        />
        <Route
          path="/global_exchange"
          element={
            <PrivateRoute>
              <GlobalExchange/>
            </PrivateRoute>
          }
        />
        <Route
          path="/countries"
          element={
            <PrivateRoute>
              <Countries />
            </PrivateRoute>
          }
        />
        <Route
          path="/currencies"
          element={
            <PrivateRoute>
              <Currencies />
            </PrivateRoute>
          }
        />
        <Route
          path="/price_config"
          element={
            <PrivateRoute>
              <PriceConfig />
            </PrivateRoute>
          }
        />
        
        
        <Route
          path="/sliders"
          element={
            <PrivateRoute>
              <Sliders />
            </PrivateRoute>
          }
        />

        <Route
          path="/settings"
          element={
            <PrivateRoute>
              <Settings />
            </PrivateRoute>
          }
        />

        {/* 🛡️ Fraud Management Routes */}
        <Route
          path="/fraud/dashboard"
          element={
            <PrivateRoute>
              <FraudDashboard />
            </PrivateRoute>
          }
        />
        <Route
          path="/fraud/logs"
          element={
            <PrivateRoute>
              <FraudLogs />
            </PrivateRoute>
          }
        />
        <Route
          path="/fraud/blacklist"
          element={
            <PrivateRoute>
              <Blacklist />
            </PrivateRoute>
          }
        />
        <Route
          path="/fraud/rules"
          element={
            <PrivateRoute>
              <FraudRules />
            </PrivateRoute>
          }
        />
        <Route
          path="/fraud/suspended"
          element={
            <PrivateRoute>
              <SuspendedUsers />
            </PrivateRoute>
          }
        />

      </Routes>
    </div>
  );
}

export default App;